module.exports = __webpack_public_path__ + "static/media/footer_3.2f1a2d64.png";